import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider, useLang } from "@/i18n";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import ColorStudio from "@/components/ColorStudio";
import Brochures from "@/components/Brochures";
import Works from "@/components/Works";
import Process from "@/components/Process";
import Warranty from "@/components/Warranty";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

function Site() {
  const { dir } = useLang();

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    const onClick = (e) => {
      const anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      const target = document.querySelector(anchor.getAttribute("href"));
      if (target) {
        e.preventDefault();
        lenis.scrollTo(target, { offset: -76 });
      }
    };
    document.addEventListener("click", onClick);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      document.removeEventListener("click", onClick);
    };
  }, []);

  return (
    <div dir={dir} className="min-h-screen bg-[#000000] font-body text-[#F5F2EB] antialiased">
      <div className="grain-overlay" aria-hidden="true" />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <ColorStudio />
        <Brochures />
        <Works />
        <Process />
        <Warranty />
        <Contact />
      </main>
      <Footer />
      <Toaster position="top-center" richColors theme="dark" />
    </div>
  );
}

export default function App() {
  return (
    <LanguageProvider>
      <Site />
    </LanguageProvider>
  );
}
